import { resolveFlag } from '../services/launchDarkly';
import { generalStore } from '../stores/generalStore';

import { getParam } from './marketingHelper';

// The promo link that opened this page load (PLT-846). Read from the boot query string, not the
// profile: the backend keeps `utm_promo` on the profile across sessions, and a reopen without the
// link must run the regular popup flow. `pc` is not read here: PromotionStore reads it from the live
// URL on purpose, because the promo dialogs strip it once shown.
export const getLinkPromo = (): { utmPromo: string | null } => {
  const params = new URLSearchParams(generalStore.appBootParams);
  return { utmPromo: getParam(params, 'utm_promo') };
};

export const isLinkPromoPriorityEnabled = () => resolveFlag('prioritize_link_promo_popup', false);

// `utm_promo` stays in the URL (login and analytics read it), so a reload in the same tab would see
// the link again. The priority is given once per tab: a reload runs the regular flow, a new tab
// opened from the link gets it again.
const prioritizedKey = (utmPromo: string) => `linkPromoPrioritized:${utmPromo}`;

export const wasLinkPromoPrioritized = (utmPromo: string) => {
  try {
    return sessionStorage.getItem(prioritizedKey(utmPromo)) !== null;
  } catch {
    // Storage unavailable (e.g. private mode): behave as not yet prioritized
    return false;
  }
};

export const markLinkPromoPrioritized = (utmPromo: string) => {
  try {
    sessionStorage.setItem(prioritizedKey(utmPromo), '1');
  } catch {
    // Storage unavailable (e.g. private mode): nothing to remember
  }
};
